<!--
 * @Description: 网盘
 * @Author: PF
 * @Date: 2024-06-07 10:42:03
 * @LastEditors: PF
 * @LastEditTime: 2024-06-14 15:38:17
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">网盘</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="pl0 pr0">
          <!-- 网盘类型:0-学校，1-个人网盘，2-部门网盘 -->
          <el-tabs v-model="activeName">
            <el-tab-pane label="学校网盘" :name="0"></el-tab-pane>
            <el-tab-pane label="部门网盘" :name="2"></el-tab-pane>
            <el-tab-pane label="我的网盘" :name="1"></el-tab-pane>
          </el-tabs>
        </el-header>
        <el-main class="pl0 pr0 pb0">
          <xuexiaowangpan v-if="activeName===0" />
          <bumenwangpan v-if="activeName===2" />
          <wodewangpan v-if="activeName===1" />
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { homeCloseWindow } from '@/api/common.js'
import xuexiaowangpan from './xuexiaowangpan.vue'
import bumenwangpan from './bumenwangpan.vue'
import wodewangpan from './wodewangpan.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const activeName = ref(0)
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'wangpan') {
      openList.value = true
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.list-page) {
  padding: 0;
}
</style>
